import { gql } from '@apollo/client';

export const ADD_STAKEHOLDERS_TO_ORGANISATION = gql`
  mutation AddStakeholdersToOrganisation($inputs: CreateStakeholdersInput!) {
    stakeholders: addStakeholdersToOrganisation(inputs: $inputs) {
      id
    }
  }
`;
